import cn from 'classnames'
import {FC} from 'react'

import {USER_TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {SectionIntro, SectionIntroProps} from './SectionIntro'

type SectionLayoutProps = SectionIntroProps & {
  orientation?: 'horizontal' | 'vertical'
  isReversed?: boolean
  verticalAlign?: 'top' | 'middle'
}

export const SectionLayout: FC<React.PropsWithChildren<SectionLayoutProps>> = ({
  title,
  description,
  buttons,
  maxWidth,
  isFixedWidth,
  align,
  additionalContent,
  orientation = 'vertical',
  isReversed = false,
  verticalAlign = 'middle',
  label,
  children,
}) => (
  <>
    <div className={cn(orientation === 'horizontal' ? 'wrapper' : '', isReversed && 'reversed')}>
      <SectionIntro
        label={label}
        title={title}
        description={description}
        buttons={buttons}
        maxWidth={maxWidth}
        align={align}
        additionalContent={additionalContent}
        isFixedWidth={isFixedWidth}
      />
      {children}
    </div>

    <style jsx>{`
      .wrapper {
        display: flex;
        align-items: ${verticalAlign === 'top' ? 'flex-start' : 'center'};
        justify-content: space-between;
      }
      .reversed {
        flex-direction: row-reverse;
      }
      @media ${USER_TABLET_SCREENSIZE} {
        .wrapper {
          flex-direction: column;
          align-items: center;
        }
      }
    `}</style>
  </>
)
